import React from 'react';
import { company } from '../../data/companyData';

export default class ContactMap extends React.Component {
    render(){
        return (
            <>
                <div className="contact-page-google-map">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <iframe
                                    title={`${company.name} service area`}
                                    src="https://www.google.com/maps?q=Hockley,%20TX%2077447&output=embed"
                                    className="contact-page-google-map__one" allowFullScreen>
                                </iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
